import { render, staticRenderFns } from "./IdentificacaoDePagamento.vue?vue&type=template&id=ca94d876"
import script from "./IdentificacaoDePagamento.vue?vue&type=script&lang=js"
export * from "./IdentificacaoDePagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports